new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        banners: {
            bandCommuniqueDropdown: false,
        },
        mobile: (window.innerWidth > 991) ? false : true,
        tabletPortrait: (window.innerWidth > 767) ? true : false
    },
    created() {
        window.addEventListener("resize", this.screenHandler);
    },
    mounted() {
        this.secondBlock = true;
    },
    destroyed() {
        window.removeEventListener("resize", this.screenHandler);
    },
    methods: {
        screenHandler() {
            this.mobile = (window.innerWidth > 991) ? false : true;
            this.tabletPortrait = (window.innerWidth > 767) ? true : false;
        }
    }
})

//sliders
$(document).ready(function () {
    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        arrows: true,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: true,
        //fade: true,
        infinite: true,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 1500,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function (event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    waitForElementToExist('.product-ratings').then(element => {
        $('.product-ratings-list').slick({
            swipeToSlide: true,
            touchThreshold: 100,
            arrows: true,
            dots: true,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            autoplaySpeed: 1000,
            autoplay: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                }
            ]
        });
    });

    function startStopwatch(stopwatchElement) {
        if (stopwatchElement.dataset.stopwatchInitialized) return;
        stopwatchElement.dataset.stopwatchInitialized = 'true';

        const dataInitStr = stopwatchElement.getAttribute('data-init');
        const dataEndStr = stopwatchElement.getAttribute('data-end');

        if (!dataInitStr || !dataEndStr) return;

        const dataInit = new Date(dataInitStr);
        const dataEnd = new Date(dataEndStr);

        if (isNaN(dataInit.getTime()) || isNaN(dataEnd.getTime())) return;

        const cronometroEl = stopwatchElement.querySelector('#cronometro');
        if (!cronometroEl) return;

        function formatarDigitos(numero) {
            return `<span>${numero.toString().padStart(2, '0')}</span>`;
        }

        let intervalo;

        function atualizar() {
            const agora = new Date().getTime();
            const initTimestamp = dataInit.getTime();
            const endTimestamp = dataEnd.getTime();

            let tempoRestante;
            let prefixo = '';

            if (agora < initTimestamp) {
                tempoRestante = initTimestamp - agora;
                prefixo = 'Inicia em ';
                stopwatchElement.classList.remove('active');
            } else if (agora < endTimestamp) {
                tempoRestante = endTimestamp - agora;
                stopwatchElement.classList.add('active');
            } else {
                cronometroEl.innerHTML = 'Tempo esgotado!';
                stopwatchElement.classList.remove('active');
                clearInterval(intervalo);
                return;
            }

            const dias = Math.floor(tempoRestante / (1000 * 60 * 60 * 24));
            const horas = Math.floor((tempoRestante % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutos = Math.floor((tempoRestante % (1000 * 60 * 60)) / (1000 * 60));
            const segundos = Math.floor((tempoRestante % (1000 * 60)) / 1000);

            cronometroEl.innerHTML = `<div>${prefixo}${formatarDigitos(dias)}d ${formatarDigitos(horas)}h ${formatarDigitos(minutos)}m ${formatarDigitos(segundos)}s</div>`;
        }

        intervalo = setInterval(atualizar, 1000);
        atualizar();
    }

    function mostrarAvisoCupom(cupom) {
        const avisoExistente = document.querySelector('.cupom-copiado-aviso');
        if (avisoExistente) avisoExistente.remove();

        const aviso = document.createElement('div');
        aviso.className = 'cupom-copiado-aviso';
        aviso.textContent = `Cupom ${cupom} copiado!`;
        aviso.style.cssText = `
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    background: #000;
    color: #fff;
    padding: 12px 24px;
    border-radius: 4px;
    z-index: 9999;
    font-size: 14px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.2);
  `;

        document.body.appendChild(aviso);

        setTimeout(() => {
            aviso.remove();
        }, 3000);
    }

    function copiarFallback(texto) {
        const textarea = document.createElement('textarea');
        textarea.value = texto;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'absolute';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();

        try {
            document.execCommand('copy');
            mostrarAvisoCupom(texto);
        } catch (err) {
            alert('Não foi possível copiar o cupom automaticamente. Cupom: ' + texto);
        }

        document.body.removeChild(textarea);
    }

    function initCupomCopy() {
        document.querySelectorAll('.stopwatch button[data-cupom]').forEach(button => {
            if (button.dataset.cupomInitialized) return;
            button.dataset.cupomInitialized = 'true';

            button.addEventListener('click', function () {
                const cupom = this.getAttribute('data-cupom');
                if (!cupom) return;

                if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(cupom)
                        .then(() => mostrarAvisoCupom(cupom))
                        .catch(() => copiarFallback(cupom));
                } else {
                    copiarFallback(cupom);
                }
            });
        });
    }

    function initStopwatches() {
        document.querySelectorAll('.stopwatch').forEach(startStopwatch);
    }

    function initAll() {
        initStopwatches();
        initCupomCopy();
    }

    function observeChanges() {
        const observer = new MutationObserver(function () {
            initAll();
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            initAll();
            observeChanges();
        });
    } else {
        initAll();
        observeChanges();
    }

    waitForElementToExist('.home__faq').then(element => {
        const faqItems = document.querySelectorAll('.home__faq--list-item');

        if (faqItems.length > 0) {
            faqItems.forEach(item => {
                item.addEventListener('click', () => {
                    item.classList.toggle('active');
                });
            });
        }
    });

    waitForElementToExist('.categories').then(element => {
        // Verifica se tem pelo menos 8 filhos em desktop
        if (window.innerWidth >= 992) {
            const container = document.querySelector('#categories-home-carrousel');
            const items = Array.from(container.children);

            if (items.length < 8) {
                // Não inicializa o slick se tiver menos de 8 itens em desktop
                console.log('Slick não inicializado - menos de 8 itens em desktop:', items.length);
                return;
            }
        }

        $('#categories-home-carrousel').slick({
            arrows: false,
            dots: true,
            autoplay: true,
            autoplaySpeed: 3000,
            mobileFirst: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            speed: 1000,
            infinite: true,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 8,
                    }
                }
            ]
        });
    });

    waitForElementToExist('.faixa-cupom').then(element => {
        // Delegado: a faixa duplica o cupom (clones do slick / marquee no mobile)
        document.addEventListener("click", (e) => {
            const formButton = e.target.closest('.faixa-cupom-form p');
            if (!formButton) return;
            e.preventDefault();

            const valueElement = formButton.parentElement.querySelector('[data-value]');
            if (!valueElement) return;
            const newValueInput = valueElement.getAttribute('data-value');

            navigator.clipboard.writeText(newValueInput);

            alert("Valor copiado: " + newValueInput);
        });
    });





    waitForElementToExist('.first-banner').then(element => {
        const banner = element.querySelector('#banner-categorias');

        if (banner) {
            $('#banner-categorias').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,

                responsive: [
                    {
                        breakpoint: 991,
                        settings: "unslick"
                    }
                ]
            });
        }
    });

    waitForElementToExist('.first-vitrine').then(element => {
        const firstCarrousel = element.querySelector('.product_list');
        if (firstCarrousel) {
            $('.product_list').slick({
                arrows: true,
                prevArrow: $(".count-1 .count-prev"),
                nextArrow: $(".count-1 .count-next"),
                dots: false,
                infinite: true,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 700,

                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('.product_list').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }

        /* Fix bug with slick on new product render (vitrine) */
        const elementosLazy = document.querySelectorAll('.lazy-img');

        elementosLazy.forEach(elemento => {
            const dataSrc = elemento.getAttribute('data-src');
            if (dataSrc) {
                elemento.setAttribute('src', dataSrc);
                elemento.removeAttribute('data-src');
            }
        });
    });

    waitForElementToExist('.second-vitrine').then(element => {
        const firstCarrousel = element.querySelector('.product_list');
        if (firstCarrousel) {
            $('.second-vitrine .product_list').slick({
                arrows: true,
                prevArrow: $(".count-2 .count-prev"),
                nextArrow: $(".count-2 .count-next"),
                dots: false,
                infinite: true,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 700,

                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('.second-vitrine .product_list').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }

        /* Fix bug with slick on new product render (vitrine) */
        const elementosLazy = document.querySelectorAll('.lazy-img');

        elementosLazy.forEach(elemento => {
            const dataSrc = elemento.getAttribute('data-src');
            if (dataSrc) {
                elemento.setAttribute('src', dataSrc);
                elemento.removeAttribute('data-src');
            }
        });
    });

    waitForElementToExist('.third-vitrine').then(element => {
        const firstCarrousel = element.querySelector('.product_list');
        if (firstCarrousel) {
            $('.third-vitrine .product_list').slick({
                arrows: true,
                prevArrow: $(".count-3 .count-prev"),
                nextArrow: $(".count-3 .count-next"),
                dots: false,
                infinite: true,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 700,

                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('.third-vitrine .product_list').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }

        /* Fix bug with slick on new product render (vitrine) */
        const elementosLazy = document.querySelectorAll('.lazy-img');

        elementosLazy.forEach(elemento => {
            const dataSrc = elemento.getAttribute('data-src');
            if (dataSrc) {
                elemento.setAttribute('src', dataSrc);
                elemento.removeAttribute('data-src');
            }
        });
    });



    waitForElementToExist('.banner-momentos').then(element => {
        const banner = element.querySelector('#banner-momentos');

        if (banner) {
            $('#banner-momentos').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,

                responsive: [
                    {
                        breakpoint: 991,
                        settings: "unslick"
                    }
                ]
            });
        }
    });

    // waitForElementToExist('.faixa-comunicado').then(element => {
    //     const banner = element.querySelector('#faixa-comunicado');

    //     if(banner) {
    //         $('#faixa-comunicado').slick({
    //             arrows: false,
    //             dots: false,
    //             infinite: false,
    //             mobileFirst: true,
    //             autoplay: true,
    //             slidesToShow: 1,
    //             slidesToScroll: 1,
    //             speed: 700,

    //             responsive: [
    //                 {
    //                     breakpoint: 991,
    //                     settings: "unslick"
    //                 }
    //             ]
    //         });
    //     }
    // });

    waitForElementToExist('.banner-instagram').then(element => {
        const banner = element.querySelector('.banner-instagram__list');

        if (banner) {
            $('.banner-instagram__list').slick({
                arrows: true,
                prevArrow: $(".banner-instagram .count-3 .count-prev"),
                nextArrow: $(".banner-instagram .count-3 .count-next"),
                dots: false,
                infinite: true,
                mobileFirst: true,
                autoplay: false,
                rows: 2,
                slidesPerRow: 2,
                speed: 1000,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 5,
                            rows: 1,
                            slidesPerRow: 1,
                        }
                    }
                ]
            });
        }
    });

    waitForElementToExist('.banner-product').then(element => {
        $('#product-banner').slick({
            swipeToSlide: true,
            touchThreshold: 100,
            swipeToSlide: true,
            touchThreshold: 100,
            arrows: true,
            prevArrow: $(".count-5 .count-prev"),
            nextArrow: $(".count-5 .count-next"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
        });

        $('.banner-products').slick({
            swipeToSlide: true,
            touchThreshold: 100,
            swipeToSlide: true,
            touchThreshold: 100,
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
        });

        $('#product-banner').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $('.banner-products').slick('slickGoTo', nextSlide);
        });


        $('#product-banner').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    });
})